import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function useIsOnPage(urls: string[]) {
  const location = useLocation();
  const [isOnPage, setIsOnPage] = useState(false);

  useEffect(() => {
    setIsOnPage(urls.includes(location.pathname));
  }, [location.pathname, urls]);

  return isOnPage;
}
